import React from "react";
import { Accordion, Checkbox } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekTextField } from "../inputs";
import { hasLastReceivedYear, } from "../../utils/lastReceivedFilter";
export var LastReceivedFilterAccordion = function (_a) {
    var values = _a.values, yearInvalid = _a.yearInvalid, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var yearSet = hasLastReceivedYear(values.lastReceivedYear);
    return (React.createElement(Accordion, { label: formatMessage({ id: "ui-br-legaldeposits.filter.lastReceived" }), separator: false },
        React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.lastReceived.year", value: values.lastReceivedYear, inputMode: "numeric", onChange: function (e) {
                return onChange({ lastReceivedYear: e.target.value });
            }, placeholder: formatMessage({
                id: "ui-br-legaldeposits.filter.lastReceived.year.placeholder",
            }), error: yearInvalid
                ? formatMessage({
                    id: "ui-br-legaldeposits.filter.lastReceived.year.invalid",
                })
                : undefined }),
        React.createElement(Checkbox, { label: formatMessage({
                id: "ui-br-legaldeposits.filter.lastReceived.includeOlder",
            }), checked: yearSet && values.lastReceivedIncludeOlder, disabled: !yearSet, onChange: function (e) {
                return onChange({ lastReceivedIncludeOlder: e.target.checked });
            } }),
        React.createElement(Checkbox, { label: formatMessage({
                id: "ui-br-legaldeposits.filter.lastReceived.neverReceived",
            }), checked: values.neverReceived, onChange: function (e) {
                return onChange({ neverReceived: e.target.checked });
            } })));
};
